// Re-export shared constants for external consumers (e.g. pages, utils).
// Implementation lives in flag.off/; update both flag folders when constants change.
export * from './flag.off/constants'
